export default "__VITE_ASSET__hHqOj74G__"